/** @format */

import React, { useState } from 'react'
import localize from '../../../../../../Global/Localize'
import { Reorder } from 'framer-motion'

export const ViewCompanyMiscellaneous = ({ selectedCompany }) => {
  const [priorityList, setPriorityList] = useState(
    (
      selectedCompany?.recoveryPriority?.split(',') || [
        'BosaLoans',
        'BosaInvestments',
        'BosaSavings',
        'FosaLoans',
        'FosaInvestments',
        'FosaSavings',
        'BosaLoans',
        'BosaInvestments',
        'BosaSavings',
      ]
    ).map((val, idx) => {
      return {
        id: idx,
        label: val,
      }
    }),
  )

  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('transactionReceiptTopIndentation')}
          </label>
          <input
            type="number"
            className="form-control"
            value={selectedCompany?.transactionReceiptTopIndentation}
            disabled
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('transactionReceiptLeftIndentation')}
          </label>
          <input
            type="number"
            className="form-control"
            value={selectedCompany?.transactionReceiptLeftIndentation}
            disabled
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('transactionReceiptFooter')}
          </label>
          <input
            type="number"
            className="form-control"
            value={selectedCompany?.transactionReceiptFooter}
            disabled
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('biometricsThreshold')}
          </label>
          <input
            className="form-control"
            type="number"
            value={selectedCompany?.biometricsThreshold}
            disabled
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('maximumLoanEligibilityInvestmentsMultiplier')}
          </label>
          <input
            className="form-control"
            type="number"
            value={selectedCompany?.maximumLoanEligibilityInvestmentsMultiplier}
            disabled
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('logoMaxWidth')}
          </label>
          <input
            className="form-control"
            value={selectedCompany?.maxImageWidth}
            disabled
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('logoMaxHeight')}
          </label>
          <input
            className="form-control"
            value={selectedCompany?.maxImageHeight}
            disabled
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('defaultCustomerFilter')}
          </label>
          <input
            value={selectedCompany?.defaultCustomerFilterDescription}
            disabled
            className="form-control"
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('customerStatementPassword')}
          </label>
          <input
            value={selectedCompany?.customerStatementPasswordDescription}
            className="form-control"
            disabled
          />
        </div>
        <div className="col d-flex align-items-center">
          <label className="col-3 text-capitalize">
            {localize('reportDisplayName')}
          </label>
          <input
            className="form-control"
            value={selectedCompany?.applicationDisplayName}
            disabled
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col d-flex align-items-center">
          <label
            style={{ marginBottom: 15 + 'rem' }}
            className="col-3 text-capitalize"
          >
            {localize('recoveryPriority')}
          </label>
          <div
            style={{
              width: '100%',
              pointerEvents: 'none',
              opacity: 0.6,
            }}
          >
            <Reorder.Group
              values={priorityList || []}
              className={`form-control basicdnd-container ${'y'}-axis`}
              axis={'y'}
              onReorder={setPriorityList}
              layout
            >
              {priorityList.map((item, index) => (
                <Reorder.Item
                  value={item}
                  key={item.id}
                  className="basicdnd-item"
                >
                  {item.label}
                </Reorder.Item>
              ))}
            </Reorder.Group>
          </div>
        </div>

        <div className="col d-flex align-items-center">
          <label
            className="col-3 text-capitalize"
            style={{ marginBottom: 15 + 'rem' }}
          >
            {localize('customerStatementFooter')}
          </label>
          <input
            style={{ marginBottom: 15 + 'rem' }}
            className="form-control"
            value={selectedCompany?.customerStatementFooter}
            disabled
          />
        </div>
      </div>
    </>
  )
}
